module.exports = "/assets/site/images/furchtne_bodrogi_karolina.jpg?5dd9bff4eb7d8047e41aae3c25e791d1";